<div
  *ngIf="now < news.endDate"
  [class.open]="opened"
  class="news-post mt-2 p-4 show"
>
  <div class="title h4 mb-3 text-center font-weight-bold">
    {{ news.headertext }}
  </div>
  <div
    class="description text-center"
    *ngIf="news.body && news.body.length > 0"
    [innerHTML]="news.body"
  ></div>
  <app-gallery
    *ngIf="news.picPath"
    folder="news"
    picNum="1"
    [picPath]="news.picPath"
  ></app-gallery>
  <div class="docs" *ngIf="news.documents && news.documents.length > 0">
    <ul class="my-3 text-center">
      <li
        *ngFor="let doc of news.documents"
        (click)="download(doc.name, doc.ext, doc.path)"
      >
        <i
          [ngClass]="
            doc.ext && (doc.ext === '.xls' || doc.ext === '.xlsx')
              ? 'fa-file-excel'
              : doc.ext &&
                (doc.ext === '.odt' ||
                  doc.ext === '.doc' ||
                  doc.ext === '.docx')
              ? 'fa-file-word'
              : 'fa-file-pdf'
          "
          class="fas mr-3"
        ></i
        >{{ doc.name }}
      </li>
    </ul>
  </div>
  <div class="date text-right mt-2 mb-3">
    {{ news.date | date: "yyyy. MM. dd." }}
  </div>
  <div class="opener">
    <span class="link" (click)="opened = !opened">{{
      opened ? "Bezár" : "Tovább olvasom..."
    }}</span>
  </div>
</div>
